import { useSubjectDiscipline } from './useSubjectDiscipline';

export { useSubjectDiscipline };
